/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */

import { datadogRum } from '@datadog/browser-rum'

const packageJson = require('../../../package.json')

export const SERVICE_NAME = 'p2pnodeweb'
export const APPLICATION_ID = {
  PRODUCTION: '995d779b-0255-4683-8ade-2d22de336d84',
  QA: '1f1b3178-7ec8-41c9-9c0d-f4617ab88dd5',
}
export const CLIENT_ID = {
  PRODUCTION: 'pubb459a1ea009d98a5fa500b4caf410bfe',
  QA: 'pubda93dee352c4911affe1f90ff0a1c706',
}

export const DATADOG_RUM_SITE = 'us5.datadoghq.com'

/* istanbul ignore next */
export function getClientEnvironment() {
  const hostname = typeof window !== 'undefined' ? window.location.host : ''
  if (hostname.includes('localhost')) {
    return 'DEVELOPMENT'
  }
  if (hostname.includes('qa.paypal.com')) {
    return 'STAGE'
  }
  if (hostname.includes('sandbox.paypal.com')) {
    return 'SANDBOX'
  }
  if (hostname.includes('paypal.com')) {
    return 'PRODUCTION'
  }

  return undefined
}

/* istanbul ignore next */
function getDDTraceLink(correlationId) {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return `https://go/ddprod/trace?${correlationId}`
    case 'SANDBOX':
      return `https://go/ddsb/trace?${correlationId}`
    default:
      return `https://go/ddqa/trace?${correlationId}`
  }
}

/* istanbul ignore next */
function getCalLogLink(correlationId) {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return `https://go/ddprod/tocal?${correlationId}`
    case 'SANDBOX':
      return `https://go/ddsb/tocal?${correlationId}`
    default:
      return `https://go/ddqa/tocal?${correlationId}`
  }
}

/* istanbul ignore next */
export function getApplicationId() {
  const environment = getClientEnvironment()
  if (environment === 'PRODUCTION') {
    return APPLICATION_ID.PRODUCTION
  }
  return APPLICATION_ID.QA
}

/* istanbul ignore next */
export function getClientToken() {
  const environment = getClientEnvironment()
  if (environment === 'PRODUCTION') {
    return CLIENT_ID.PRODUCTION
  }
  return CLIENT_ID.QA
}

/* istanbul ignore next */
function addCorrelationIdToContext(event, correlationId) {
  if (correlationId && typeof correlationId === 'string') {
    event.context.correlationId = correlationId

    const ddTraceLink = getDDTraceLink(correlationId)
    const calLogLink = getCalLogLink(correlationId)
    event.context['dd-trace-url'] = ddTraceLink
    event.context['external-cal-url'] = calLogLink
  }
}

/* istanbul ignore next */
if (typeof window !== 'undefined') {
  // init Datadog RUM
  /* istanbul ignore next */
  datadogRum.init({
    // properties for idntifying and authenticating the application with RUM
    applicationId: getApplicationId(),
    clientToken: getClientToken(),
    site: DATADOG_RUM_SITE,
    service: SERVICE_NAME,
    version: packageJson.version,
    env: process.env.NODE_ENV,
    // sampling must be set at 100 for session and 0 for recording. retention will be controlled on the backend in Datadog
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    // auto-instrumentations
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // privacy defaults to prevent leaking PII
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from activity tracking
    excludedActivityUrls: [/log/i, /fpti/i, /tealeaf/i, /tracking\/ts/i],
    // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from universal tracing
    allowedTracingUrls: [
      url =>
        !(
          url.includes('log') ||
          url.includes('fpti') ||
          url.includes('tealeaftarget') ||
          url.includes('tracking/ts')
        ) && url.includes('paypal.com'),
    ],
    beforeSend(event, context) {
      // modify RUM events to include the correlationId and links to logs and traces
      // for the request because we don't yet have universal tracing
      if (event.type === 'resource') {
        // handle fetch
        if (
          'response' in context &&
          context?.response &&
          context?.response?.headers
        ) {
          const correlationId = context.response.headers.get('Paypal-Debug-Id')
          addCorrelationIdToContext(event, correlationId)
        }
        // handle XHR
        if (
          'xhr' in context &&
          context.xhr &&
          'getResponseHeader' in context.xhr &&
          typeof context.xhr.getResponseHeader === 'function'
        ) {
          const correlationId = context.xhr.getResponseHeader('Paypal-Debug-Id')
          addCorrelationIdToContext(event, correlationId)
        }
      }
      return true
    },
  })
}
